import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useEffect } from 'react';
import { useSocketSend } from '../../context/webSocket/webSocketContext';
import { thunkSetScene } from '../../redux/actions/sceneActions';
import { useAppDispatch } from '../../redux/store';
export const RoomToRoomTransitionScene = ({ toRoomSceneType }) => {
    const dispatch = useAppDispatch();
    const socketSend = useSocketSend();
    useEffect(() => {
        dispatch(thunkSetScene(toRoomSceneType, socketSend));
    }, [dispatch, socketSend, toRoomSceneType]);
    return _jsx("div", {});
};
